import React from "react";
import { Box, TableCell } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";

// Columna "Analista": nombre del analista asignado; al pasar el mouse (si hay
// permiso y el estado es elegible) se reemplaza por el ícono de editar.
export default function CeldaAnalista({
  data,
  analistas,
  tienePermisoEditarAnalista,
  handleEditarAnalista,
  handlePopoverOpen,
}) {
  return (
    <TableCell align="center">
      <Box
        sx={{
          position: "relative",
          display: "inline-block",
          maxWidth: "100%",
          px: 1,
          ...(tienePermisoEditarAnalista() && (data.idEstadoVerificacionSolicitud == 10 || data.idEstadoVerificacionSolicitud == 12) && {
            "&:hover .analistaNombre": {
              opacity: 0,
              visibility: "hidden",
            },
            "&:hover .editIcon": {
              opacity: 1,
              visibility: "visible",
            },
          }),
        }}
      >
        {/* Nombre del analista */}
        <Box
          className="analistaNombre"
          sx={{
            transition: "opacity 0.2s ease",
            fontWeight: 500,
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        >
          {analistas.find((a) => a.idUsuario === data.idAnalista)?.Nombre || "No disponible"}
        </Box>

        {/* Ícono de editar solo si tiene permiso */}
        {tienePermisoEditarAnalista() && (
          <Box
            className="editIcon"
            onClick={() => handleEditarAnalista(data)}
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              textAlign: "center",
              opacity: 0,
              visibility: "hidden",
              color: "#6b7280",
              cursor: "pointer",
              transition: "opacity 0.2s ease",
            }}
          >
            <EditIcon fontSize="small" />
          </Box>
        )}
        <span
          style={{
            // pointerEvents: estaDeshabilitado(data)
            //   ? "none"
            //   : "auto",
            // opacity: estaDeshabilitado(data) ? 0.5 : 1,
          }}
        >
          <MoreVertIcon
            onClick={(event) =>
              handlePopoverOpen(event, 8, data)
            }
            style={{ cursor: "pointer" }}
          />
        </span>
      </Box>
    </TableCell>
  );
}
